"use client";

import { useLinkStatus } from "next/link";

import { cn } from "@/lib/utils";

/**
 * Departure-board pending cue for a `<Link>`: a 2px forest-green line along the
 * nearest positioned ancestor's bottom edge while the navigation is pending. Must
 * render inside the `<Link>` (useLinkStatus reads the enclosing link), and the
 * link (or, for a stretched link, the card) needs `relative`. The sweep and its
 * 150ms paint delay live in `.link-pending-line` in globals.css.
 */
export function LinkPendingUnderline({ className }: { className?: string }) {
  const { pending } = useLinkStatus();
  if (!pending) return null;

  return (
    <span
      aria-hidden="true"
      data-link-pending=""
      className={cn(
        "link-pending-line pointer-events-none absolute inset-x-0 bottom-0 h-0.5 bg-[#2D5A4A]",
        className,
      )}
    />
  );
}
